import { FILE_BASE_URL } from "../../app/api";

export function parseChatDate(value) {
  const raw = value || Date.now();
  const normalized =
    typeof raw === "string" && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)
      ? raw.replace(" ", "T")
      : raw;
  const date = new Date(normalized);

  return Number.isNaN(date.getTime()) ? new Date() : date;
}

export function getDayKey(date) {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
}

export function getChatDayLabel(date) {
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (getDayKey(date) === getDayKey(today)) return "Today";
  if (getDayKey(date) === getDayKey(yesterday)) return "Yesterday";

  return date.toLocaleDateString([], {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatChatDateTime(value, fallback = "Not available") {
  if (!value) return fallback;
  const date = parseChatDate(value);

  if (Number.isNaN(date.getTime())) return fallback;

  return date.toLocaleString([], {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getGroupImageUrl(group) {
  const raw =
    group?.image ||
    group?.image_url ||
    group?.group_image ||
    group?.group_image_url ||
    group?.profile_pic ||
    group?.avatar ||
    "";

  if (!raw) return "";
  if (raw.startsWith("blob:") || raw.startsWith("http")) return raw;
  return `${FILE_BASE_URL}${raw}`;
}

export function getMediaUrl(path = "") {
  if (!path) return "";
  if (path.startsWith("blob:") || path.startsWith("http")) return path;
  return `${FILE_BASE_URL}/${path.startsWith("/") ? path.slice(1) : path}`;
}

export function safeJsonParse(value, fallback = null) {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

export function getStoredUser(fallback = {}) {
  return safeJsonParse(localStorage.getItem("user"), fallback) || fallback;
}
